import { useEffect, useState } from 'react';
import TaskUnit from './TaskUnit';
import axios from 'axios';
import Popup from './Popup';
import { useAppContext } from './AppContext';
import { openLinkFp, openTelegramLinkFp } from '@tma.js/sdk';

enum TaskStatus {
  Initial = 'initial',
  Check = 'check',
  Loading = 'loading',
  Done = 'done',
};

type Task = {
  id: string;
  title: string;
  link: string;
  icon: string; // change to enum
  buttonText: string;
  done: boolean;
  status: TaskStatus; // track button status
};

type Popup = {
  taskId: number;
  message: string;
};


const TasksPage = () => {
  const { loginData, telegramData } = useAppContext();
  const [tasks, setTasks] = useState<Task[]>([]);
  const [loading, setLoading] = useState(true);
  const [activePopup, setActivePopup] = useState<Popup | null>(null);

  useEffect(() => {
    const fetchTasks = async () => {
      if (!telegramData) return
      try {
        const response = await axios.get<Task[]>(`${telegramData.settings.apiHost}/task/${telegramData.user.id}`);
        if (Array.isArray(response.data)) {
          const tasksWithStatus = response.data.map(task => ({
            ...task,
            status: task.done ? TaskStatus.Done : TaskStatus.Initial,
          }));
          setTasks(tasksWithStatus);
        } else {
          console.error('Expected an array but got:', response.data);
          setTasks([]);
        }
      } catch (error) {
        console.error('Error fetching tasks:', error);
        setTasks([]);
      } finally {
        setLoading(false);
      }
    };

    fetchTasks();
  }, [telegramData]);

  const closePopup = () => setActivePopup(null);

  const handleOpenTaskLink = (task: Task) => {
    // Open the task link in a new tab
    var _link = task.link
    if (_link.startsWith('@')) {
      _link = `https://t.me/${_link.slice(1)}`;
      openTelegramLinkFp(_link);      
    } else {
      //window.open(_link, '_blank');
      openLinkFp(_link);
    }

    // Update task status to 'check'
    setTasks(prevTasks =>
      prevTasks.map(t => t.id === task.id ? { ...t, status: TaskStatus.Check } : t)
    );
  };

  const handleVerifyTask = async (task: Task) => {
    if (!telegramData) return
    var popupMessage = ""

    // if (task.status == TaskStatus.Done) {
    //   popupMessage = "testMessage"
    //   setActivePopup({ taskId: Number(task.id), message: popupMessage }); 
    //   setTimeout(() => setActivePopup(null), 6000);
    //   return
    // }

    try {
      // Set status to loading for the task
      setTasks(prevTasks =>
        prevTasks.map(t => t.id === task.id ? { ...t, status: TaskStatus.Loading } : t)
      );

      const response = await axios.post(`${telegramData.settings.apiHost}/task`, {
        tgID: telegramData.user.id,
        link: task.link,
      });
      console.log("Response data: " + response.data);

      if (response.data) {
        if (!task.link.startsWith("@")) {
          await new Promise(resolve => setTimeout(resolve, 3000));
        }
        setTasks(prevTasks =>
          prevTasks.map(t => t.id === task.id ? { ...t, status: TaskStatus.Done, done: true } : t)
        );
        popupMessage = "Verification successful, the task completed"
      } else {
        setTasks(prevTasks =>
          prevTasks.map(t => t.id === task.id ? { ...t, status: TaskStatus.Initial } : t)
        );
        popupMessage = "Verification failed, the task is not completed"
      }
    } catch (error) {
      console.error('Error verifying task:', error);
      // Reset status to 'check' on error
      setTasks(prevTasks =>
        prevTasks.map(t => t.id === task.id ? { ...t, status: TaskStatus.Initial } : t)
      );
      popupMessage = "Verification failed, the task is not completed"
    }

    if (popupMessage != "") {
      setActivePopup({ taskId: Number(task.id), message: popupMessage });
      //setTimeout(() => setActivePopup(null), 6000);
    } 
    
  };

  return loginData == null ? (
    <></>
  ) : (
    <div className="flex flex-col gap-2 p-8 h-full">
      <p className='italic mb-4 text-gray-600'>Complete tasks and increase your FM Limit by x1 for each completed task.</p>

      <div className='flex flex-col gap-2'>
        <h2 className="page-header">Tasks</h2>
        <hr className="page-hr" />
      </div>     

      {loading ? (
        <div className='flex-1 flex items-center justify-center'>
          <p className='page-header italic text-gray-600'>Loading...</p>
        </div>     
      ) : tasks.length === 0 ? (
        <div className='flex-1 flex items-center justify-center'>
          <p className='page-header italic text-gray-600'>No Tasks</p>
        </div>
      ) : (
        <div>
          {tasks.map(task => (
            <TaskUnit
              key={task.id}
              task={task}
              onOpen={() => handleOpenTaskLink(task)}
              onVerify={() => handleVerifyTask(task)}
            />
          ))}
        </div>
      )}
      {activePopup && (
        <Popup
          message={activePopup.message}
          onClose={closePopup}
        />
      )} 
    </div>
  );
};

export default TasksPage;
